var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360 360",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.865,8.769h-29.729C74.079,8.769,0,82.848,0,173.903v53.081v22.354v43.826c0,32.018,26.05,58.067,58.07,58.067h31.188 c11.063,0,20.033-8.97,20.033-20.035V188.951c0-11.065-8.97-20.035-20.033-20.035H58.07c-6.273,0-12.311,1.012-17.974,2.861 c1.141-67.983,56.789-122.939,125.039-122.939h29.729c68.25,0,123.898,54.955,125.039,122.939 c-5.663-1.849-11.701-2.861-17.974-2.861h-31.188c-11.064,0-20.033,8.97-20.033,20.035v142.245c0,11.066,8.97,20.035,20.033,20.035 h31.188c32.02,0,58.07-26.049,58.07-58.067v-43.826v-22.354v-53.081C360,82.848,285.921,8.769,194.865,8.769z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02b3bc373cad1ec1300bc2b89c945b47.svg";
export { ForwardRef as ReactComponent };